/* eslint-disable react-hooks/exhaustive-deps */

import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";
import { useMemo } from "react";

import { useGetNotifications } from "../apis";

const useNotificationsList = () => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable();

  const requestParams: GetListRequestParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      search: debouncedSearch,
      orderBy: sorting[0]?.id ?? null,
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC"
    }),
    [page, debouncedSearch, sorting]
  );

  const {
    notifications,
    meta,
    isLoading,
    refetch: refetchNotifications
  } = useGetNotifications(requestParams);

  return {
    notifications,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    refetchNotifications
  };
};

export default useNotificationsList;
